import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Autocomplete from '@mui/material/Autocomplete';

import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import PrintIcon from "@mui/icons-material/Print";
import axios from "axios";
import PropTypes from "prop-types";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { connect, useDispatch } from "react-redux";
import { setSnackbar } from "../../snackbar/api/snackbar";
import { getActiveUsers } from "../../settings/api/actions";
import WorkOrderNotes from "./WorkOrderNotes";
import { formatWorkOrderAddress } from "../utils/formatWorkOrderAddress";

function UpdateWorkOrder(props) {
  const [users] = useState(props.setting.activeUsers.items || [{ id: "", label: "" }]);

  const options = users.map(user => {
    return { label: `${user.firstName} ${user.lastName}`, id: user.id }
  })

  const assignedTo = options.find(v => v.label === props.item.assignedTo);

  const [open, setOpen] = useState(props.show);
  const [item] = useState(props.item);
  const [state, setState] = useState({
    workOrderTitle: props.item.workOrderTitle || "",
    assignedTo: assignedTo?.id || "",
    workOrderStatusId: props.item.workOrderStatusId || ""
  });

  const [status] = useState(props.apl.genericTypes.workOrderStatus.data || [{ id: "", label: "" }]);

  const dispatch = useDispatch();

  const workOrderStatusOptions = status.map(status => {
    return { label: `${status.description}`, id: status.id }
  })

  const addNote = async (newNote) => {
    let body = {
      workOrderId: item.id,
      note: newNote
    }
    try {
      let repsonse = await axios.post(`/workordernote`, body)
      if (repsonse.status === 200) {
        dispatch(setSnackbar(true, "Success", `Note created.`))
      }
    } catch (e) {
      dispatch(setSnackbar(true, "error", `Failed to create note..`))

    }

  }

  const handleSave = async () => {
    //If New, call register user,

    setOpen(false);
    props.onChange(false);
    let newNote;
    if (item?.assignedTo !== state.assignedTo) {
      const orginalAssignee = options.find(v => v.label === item.assignedTo);
      const newName = options.find(v => v.id === state.assignedTo);
      if (orginalAssignee?.label && newName?.label) {
        newNote = `Work order has been reassigned from ${orginalAssignee?.label} to ${newName.label}`;
      }
      else if (newName?.label) {
        newNote = `Work order has been assigned to ${newName.label}`
      }
      else {
        newNote = `Work order has been unassigned.`
      }

      await addNote(newNote)

    }
    if (item?.workOrderStatusId !== state.workOrderStatusId) {
      let newDescription = workOrderStatusOptions.find(v => v.id === state.workOrderStatusId)
      newNote = `Status Change: ${item.description} -> ${newDescription.label}`
      await addNote(newNote)
    }

    props.updateItem(item.uuid, state);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);

  }

  const handleChange = (evt) => {
    let value = evt.target.value;
    if (evt.target.name === "isActive") value = evt.target.checked;

    setState({
      ...state,
      [evt.target.name]: value,
    });
  };

  const componentRef = useRef();

  const printWorkOrder = useCallback(async () => {
    let notes = [];
    try {
      const response = await axios.get(`/workordernote/workorder/${props.item.id}`);
      if (response.status === 200) {
        notes = response.data || [];
      }
    } catch (e) {
      // Print without notes if fetch fails
    }

    const wo = props.item;
    const title = state.workOrderTitle || wo.workOrderTitle || "";
    const creator = wo.creator || "N/A";
    const propertyName = wo.name || "N/A";
    const addressLine = formatWorkOrderAddress(wo);

    let notesHtml = "";
    if (notes.length > 0) {
      notesHtml = notes.map(note => `
        <div style="border-bottom: 1px solid #ddd; padding: 12px 0;">
          <div><strong>${note.submittedBy || "Unknown"}</strong></div>
          <div style="font-size: 12px; color: #666;">Created: ${new Date(note.created).toLocaleString()}</div>
          <div style="font-size: 12px; color: #666;">Last updated: ${new Date(note.updated).toLocaleString()}</div>
          <div style="margin-top: 6px;">${note.note || ""}</div>
        </div>
      `).join("");
    } else {
      notesHtml = "<p>No notes.</p>";
    }

    const originalTitle = document.title;
    document.title = `Work Order #${wo.id}`;

    const printContainer = document.createElement("div");
    printContainer.id = "wo-print-container";
    printContainer.innerHTML = `
      <h1 style="font-size:22px;margin-bottom:4px;">Work Order #${wo.id}</h1>
      <div style="margin-bottom:6px;font-size:14px;"><strong>Title:</strong> ${title}</div>
      <div style="margin-bottom:6px;font-size:14px;"><strong>Submitted By:</strong> ${creator}</div>
      <div style="margin-bottom:6px;font-size:14px;"><strong>Property:</strong> ${propertyName}</div>
      <div style="margin-bottom:6px;font-size:14px;"><strong>Address:</strong> ${addressLine || "N/A"}</div>
      <div style="margin-top:20px;">
        <div style="font-size:16px;font-weight:bold;border-bottom:2px solid #000;padding-bottom:4px;margin-bottom:8px;">Notes (${notes.length})</div>
        ${notesHtml}
      </div>
    `;
    document.body.appendChild(printContainer);
    document.body.classList.add("wo-printing");

    if (!document.getElementById("wo-print-styles")) {
      const style = document.createElement("style");
      style.id = "wo-print-styles";
      style.textContent = `
        @media print {
          body.wo-printing > *:not(#wo-print-container) { display: none !important; }
          #wo-print-container { display: block !important; font-family: Arial, sans-serif; padding: 20px; color: #000; }
        }
        #wo-print-container { display: none; }
      `;
      document.head.appendChild(style);
    }

    setTimeout(() => {
      window.print();
      document.title = originalTitle;
      document.body.classList.remove("wo-printing");
      printContainer.remove();
    }, 100);
  }, [props.item, state.workOrderTitle]);

  useEffect(() => {
    if (props.setting.activeUsers.items.length <= 0) {
      props.getActiveUsers();
    }
  }, [props.setting.activeUsers.items.length, props.getActiveUsers])

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="md"
        disableBackdropClick
      >
        <DialogTitle id="form-dialog-title" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>{!props.new ? `Work Order: #${props.item.id}` : "New Work Order"}</span>
          {!props.new && (
            <Button
              onClick={printWorkOrder}
              startIcon={<PrintIcon />}
              size="small"
              variant="outlined"
            >
              Print
            </Button>
          )}
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="workOrderTitle"
            name="workOrderTitle"
            value={state.workOrderTitle}
            label="Work Order Title"
            type=""
            fullWidth
            onChange={handleChange}
            required
          />
          <Autocomplete
            sx={{ my: 2 }}
            disablePortal
            isOptionEqualToValue={(option, value) => option.id === value.id}
            id="assignedTo"
            name="assignedTo"
            defaultValue={options.find(v => v.id == state.assignedTo)}
            onChange={(event, value) => setState({ ...state, assignedTo: value?.id || "" })}
            options={options}
            renderInput={(params) => <TextField {...params} label="Assigned To" />}
          />
          <Autocomplete
            sx={{ my: 2 }}
            disablePortal
            isOptionEqualToValue={(option, value) => option.id === value.id}
            id="workOrderStatusId"
            name="workOrderStatusId"
            defaultValue={workOrderStatusOptions.find(v => v.label == item.description)}
            onChange={(event, value) => setState({ ...state, workOrderStatusId: value?.id || "" })}
            options={workOrderStatusOptions}
            renderInput={(params) => <TextField {...params} label="Status" />}
          />
          <DialogActions>
            <Button onClick={handleCancel} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSave} color="secondary">
              Save
            </Button>
          </DialogActions>
          <WorkOrderNotes workOrder={props.item} />
        </DialogContent>
      </Dialog>
    </div>
  );
}
UpdateWorkOrder.propTypes = {
  // Store objects:
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  billing: PropTypes.object.isRequired,
  getActiveUsers: PropTypes.func.isRequired
  // Store object functions:
};

// Component State
function UpdateWorkOrderState(state) {
  return {
    setting: state.setting,
    apl: state.apl,
    user: state.user
  };
}

export default connect(UpdateWorkOrderState, { getActiveUsers })(
  UpdateWorkOrder
);
